
<div class="backdrop" (click)="onClose()" ></div>
<div class="alert-box"  [ngStyle]="!isDarkTheme ?{'color':'#212529','background-color':'#ffffff'} : {'color': '#ffffff','background-color': '#212529'}">
  <p>{{ message }}</p>
  <div class="alert-box-actions">
    <a  (click)="onClose()">Close</a>
  </div>
</div>
